(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CompanySchedulingController', CompanySchedulingController);

    CompanySchedulingController.$inject = ['$scope', '$state', '$stateParams', 'CompanyInfoQuery'];

    function CompanySchedulingController($scope, $state, $stateParams, CompanyInfoQuery) {
        var vm = this;
        CompanyInfoQuery.getCurrentCompanyInfo().query(function (comp) {
            if (comp)
                vm.companyId = comp.id;
        })
        //vm.serviceItemId=$stateParams.id;
        //vm.serviceItem=entity;
        //company-servants

    }
})();
